<template>
  <Modal
    @cerrar="handleCerrar"
    :linea="true"
    :footer="false"
    :mensajeHeader="tipoDeAlta ? 'Alta de servicio' : 'Alta de producto'"
    :flagHidden="true"
    colorSeparador="background: #012a56 0% 0% no-repeat padding-box;"
  >
    <div class="body-container">
      <div class="contenedor-switch" style="display:flex; align-items: center; margin-right: 10px;">
          <label class="switch">
            <!-- false producto, true servicio -->
            <input type="checkbox" v-model="tipoDeAlta" />
            <!-- @change="handleSwitchChange" -->
            <span class="slider">
            <span class="indicador" :class="{ 'producto': !tipoDeAlta, 'servicio': tipoDeAlta }"></span>
            </span>
          </label>
          <span style="margin-left: 5px; color:#707070;"></span>
        </div>
      <Input
        :labelMod="true"
        v-model="nombre"
        :heigthModal="true"
        class="inputwidth"
        placeholder="NOMBRE"
        :flagBorder="true"
        :height50="true"
        :flagSobra="true"
        :flagLabel="true"
        :isBuscador="true"
        label="Nombre*"
        :maxlength="50"
        @update:modelValue="getNombre"
        :flagMayusculas="true"

      ></Input>
      <Input
        v-if="!tipoDeAlta"
        :labelMod="true"
        v-model="codigoBarras"
        :heigthModal="true"
        class="inputwidth"
        placeholder="CÓDIGO DE BARRAS"
        :flagBorder="true"
        :height50="true"
        :flagSobra="true"
        :flagLabel="true"
        :isBuscador="true"
        label="Código de barras"
        :maxlength="50"
        @update:modelValue="getCodigoBarras"
        :flagMayusculas="true"
      ></Input>
      <Input
        :labelMod="true"
        v-model="descripcion"
        :heigthModal="true"
        class="inputwidth"
        placeholder="DESCRIPCIÓN"
        :flagBorder="true"
        :height50="true"
        :flagSobra="true"
        :flagLabel="true"
        :isBuscador="true"
        label="Descripción"
        :maxlength="50"
        @update:modelValue="getDescripcion"
        :flagMayusculas="true"
      ></Input>

      <div class="autocomplete-wrapper" v-if="!tipoDeAlta">
        <label>Categoría*</label>
        <v-autocomplete
          v-model="categoriaSeleccionada"
          :items="categoria"
          item-text="name"
          item-value="_id"
          validate-on-blur
          single-line
          hide-details="true"
          placeholder="SELECCIONE UNA CATEGORÍA"
          persistent-hint
        ></v-autocomplete>
      </div>

      <CustomMoney
        v-if="tipoDeAlta"
        v-model="costoServicio"
        label="Costo"
        :options="moneyOptions"
        :customStyle="{ width: '100%' , marginTop: '5px' }"
        :customInputStyle="{ borderColor: '#404040', height: '51px', borderRadius: 0 }"
        :customLabelStyle="{marginLeft: '32px', paddingLeft: '10px', width: '72px'}"
      ></CustomMoney>

      <CustomMoney
        v-if="tipoDeAlta"
        v-model="precioServicio"
        label="Precio"
        :options="moneyOptions"
        :customStyle="{ width: '100%' , marginTop: '5px' }"
        :customInputStyle="{ borderColor: '#404040', height: '51px', borderRadius: 0 }"
        :customLabelStyle="{marginLeft: '32px', paddingLeft: '10px', width: '72px'}"
      ></CustomMoney>

      <div class="autocomplete-wrapper" v-if="tipoDeAlta">
        <label>Tipo</label>
        <v-autocomplete
          v-model="type"
          :items="tipo"
          item-text="name"
          item-value="_id"
          validate-on-blur
          single-line
          hide-details="true"
          placeholder="SELECCIONE UN TIPO"
        ></v-autocomplete>
      </div>

      <div class="autocomplete-wrapper">
        <label>Proveedor{{tipoDeAlta ? '' : '*'}}</label>
        <v-autocomplete
          v-model="idProveedor"
          :items="proveedores"
          item-text="company_name"
          item-value="_id"
          validate-on-blur
          single-line
          hide-details="true"
          placeholder="SELECCIONE UN PROVEEDOR"
        ></v-autocomplete>
      </div>
      <div class="autocomplete-wrapper" v-if="!tipoDeAlta">
        <label>Marca*</label>
        <v-autocomplete
          v-model="marcaSeleccionada"
          :items="marca"
          item-text="name"
          item-value="_id"
          validate-on-blur
          single-line
          hide-details="true"
          placeholder="SELECCIONE UNA MARCA"
        ></v-autocomplete>
      </div>
      
      <Input
        v-if="!tipoDeAlta"
        :labelMod="true"
        v-model="codigoSat"
        :heigthModal="true"
        class="inputwidth"
        placeholder="CÓDIGO SAT"
        :flagBorder="true"
        :height50="true"
        :flagSobra="true"
        :flagLabel="true"
        :isBuscador="true"
        label="Código SAT"
        :maxlength="50"
        @update:modelValue="getSat"
        :flagMayusculas="true"
      ></Input>

      <div class="autocomplete-wrapper" v-if="tipoDeAlta">
        <label>Sucursal*</label>
        <v-autocomplete
          v-model="idSucursal"
          :items="sucursal"
          item-text="name"
          item-value="_id"
          validate-on-blur
          single-line
          hide-details="true"
          placeholder="SELECCIONE UNA SUCURSAL*"
        ></v-autocomplete>
      </div>

      <div class="autocomplete-wrapper" v-if="tipoDeAlta">
        <label>Tipo de servicio (SAT)</label>
        <v-autocomplete
          v-model="servicioSat"
          :items="claveProductos"
          item-value="clave"
          item-text="clase"
          validate-on-blur
          single-line
          hide-details="true"
          placeholder="SELECCIONE UN TIPO DE SERVICIO"
        ></v-autocomplete>
      </div>
      <div class="autocomplete-wrapper">
        <label>Unidad de medida</label>
        <v-autocomplete
          v-model="unidadSeleccionada"
          :items="unidadesMedida"
          item-value="clave"
          item-text="nombre"
          validate-on-blur
          single-line
          hide-details="true"
          placeholder="SELECCIONE UNA UNIDAD"
        ></v-autocomplete>
      </div>

      <div class="contenedor-boton">
        <button
          class="boton-registrar"
          @click="registrar"
          :disabled="getDisabled"
        >
          Registrar {{tipoDeAlta ? 'servicio':'producto'}}
        </button>
      </div>
    </div>
  </Modal>
</template>

<script>

import Modal from "../Modales/ModalBase.vue";
import Input from "../general/Form/Input.vue";
// import { Money } from "v-money";
import ApiService from "../../services/apis";
// import InputMoney from "../general/Form/InputMoney.vue";
import Swal from "sweetalert2";
import CustomMoney from '../general/Form/CustomMoney.vue'

export default {
  components: {
    Modal,
    Input,
    // Money,
    // InputMoney,
    CustomMoney
  },
  data() {
    return {
      tipoDeAlta: false,
      nombre: "",
      descripcion: "",
      codigoBarras: "",
      codigoSat: "",
      categoria: [],
      categoriaSeleccionada: null,
      marca: [],
      marcaSeleccionada: null,
      unidadesMedida: [],
      unidadSeleccionada: null,
      proveedores: null,
      idProveedor: null,
      costo: 0,
      precio: 0,
      getDisabled: false,
      idTipo: null,
      tipo: [
        { _id: 1, name: "Servicio Interno" },
        { _id: 2, name: "Servicio Externo" },
      ],
      type: 0,
      costoServicio: 0,
      precioServicio: 0,
      claveProductos: null,
      sucursal: [],
      idSucursal: '',
      servicioSat: '',
      moneyOptions: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        suffix: '',
        precision: 2,
        masked: false,
      },
    };
  },
  emits: ["cerrar", "exito"],
  props: {},
  methods: {
    handleCerrar() {
      this.limpiarCampos();
      this.$emit("cerrar");
    },
    getNombre(value) {
      this.nombre = value;
    },
    getCodigoBarras(value) {
      this.codigoBarras = value;
    },
    getDescripcion(value) {
      this.descripcion = value;
    },
    getSat(value) {
      this.codigoSat = value;
    },
    getCosto(value) {
      this.costo = value;
    },
    getPrecio(value) {
      this.precio = value;
    },
    categorias() {
      ApiService.categoria().then((categoria) => {
        this.categoria = categoria.data;
      });
    },
    async cargarProveedores() {
      await ApiService.proveedor().then((proveedor) => {
        this.proveedores = proveedor.data;
      });
    },
    async marcas() {
      await ApiService.marcaByFilter({ type: 1 }).then((marca) => {
        this.marca = marca.data;
      });
    },
    async unidadMedida() {
      await ApiService.UnidadMedida().then((data) => {
        this.unidadesMedida = data;
      });
    },
    registrar() {
      this.tipoDeAlta ? this.registrarServicio() : this.registrarProducto()
    },
    async registrarProducto() {
      this.getDisabled = true
      let datos = {
        code: "",
        name: this.nombre.toUpperCase(),
        descripcion: "",
        category: this.categoriaSeleccionada,
        stock: "",
        stock_min: "",
        provider: this.idProveedor,
        brand: this.marcaSeleccionada,
        purchase_price: '0',
        sale_price: '0',
        code_sat: this.codigoSat.toUpperCase(),
        code_bar: this.codigoBarras.toUpperCase(),
        description: this.descripcion.toUpperCase(),
        clave_unidad_sat: "",
      };

      try {
        let response = await ApiService.productoNuevo(datos);
        
        this.limpiarCampos();
        this.$emit("exito", response.data);
      } catch (error) {
        this.getDisabled = false
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.data.message,
          showConfirmButton: true,
          confirmButtonText: "Aceptar",
        });
      }
    },
    async registrarServicio() {
      this.getDisabled = true
      let datos = {
        name: this.nombre.toUpperCase(),
        provider: this.idProveedor,
        branch: this.idSucursal,
        costo: this.costoServicio,
        price: this.precioServicio,
        code_sat: this.servicioSat,
        description: this.descripcion.toUpperCase(),
        clave_unidad_sat: this.unidadSeleccionada,
        type: this.type,
      };
      try {
        let response = await ApiService.servicioNuevo(datos);
        this.limpiarCampos();
        this.$emit("exitoServicio", response.data);
      } catch (error) {
        this.getDisabled = false
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.data.message,
          showConfirmButton: true,
          confirmButtonText: "Aceptar",
        });
      }
    },
    limpiarCampos() {
      this.nombre = "";
      this.descripcion = "";
      this.codigoBarras = "";
      this.codigoSat = "";
      this.categoriaSeleccionada = null;
      this.marcaSeleccionada = null;
      this.unidadSeleccionada = null;
      this.idProveedor = null;
      this.costo = 0;
      this.precio = 0;
    },
    cargarClaves() {
      ApiService.ClaveProducto().then((data) => {
        this.claveProductos = data;
        ApiService.UnidadMedida().then((data) => {
          this.unidadesMedida = data;
        });
      });
    },
    sucursales() {
      ApiService.sucursal().then((sucursal) => {
        this.sucursal = sucursal.data;
      });
    },
  },
  async created() {},
  computed: {},
  async beforeMount() {
    this.limpiarCampos();
    this.categorias();
    await this.cargarProveedores();
    await this.marcas();
    await this.unidadMedida();
    await this.cargarClaves();
    await this.sucursales();
  },
  watch: {},
};
</script>
<style>
.swal2-container {
    z-index: 9999;
}
</style>

<style scoped>
p {
  margin-bottom: 0 !important;
}
.body-container {
  width: 941px;
  height: auto;
  display: flex;
  flex-direction: column;
  color: #707070 !important;
  padding: 0 30px;
  margin-top: 20px;
  transition: all 0.4s;
  transition: 0.7s all ease-in-out;
}
.modal-header span {
  color: #707070 !important;
}
.separador {
  width: 100%;
  margin: 13px 0;
  border-bottom: 1px solid rgb(112, 112, 112, 0.39);
}
.separadorGrueso {
  width: 238px;
  height: 6px;
  background: #000000 0% 0% no-repeat padding-box;
  position: absolute;
  top: 86px;
}
.autocomplete-wrapper label {
  position: relative;
  top: -11px;
  width: unset;
  padding: 0px 10px;
  text-align: center;
  margin-left: 30px;
  background: white;
}
.inputwidth {
  margin-top: 20px;
}
.autocomplete-wrapper {
  margin-top: 20px;
  border-radius: 0px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #404040;
  width: 100%;
  transition: all 0.6s;
  transition: 0.7s all ease-in-out;
}

.autocomplete-wrapper .v-input__slot {
  font-size: 14px;
  margin-bottom: 0 !important;
}

.autocomplete-wrapper .v-input__slot input {
  color: #333;
  margin-bottom: 0 !important;
}
.v-input__slot {
  margin-bottom: 0 !important;
}
.v-text-field {
  margin-top: 0 !important;
  padding-top: 0 !important;
  padding-left: 10px;
}
.autocomplete-wrapper-producto {
  border-radius: 0px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #404040;
  width: 80%;
  transition: all 0.8s;
  transition: 0.1s all ease-in-out;
}
.autocomplete-wrapper-producto .v-text-field {
  margin-top: 12px !important;
}
.contenedor-boton {
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
}
.boton-registrar {
  width: 170px;
  height: 40px;
  color: white;
  background-color: #012a56;
  border-radius: 6px;
  box-shadow: 0px 3px 6px #00000029;
  -webkit-box-shadow: 0px 3px 6px #00000029;
  -moz-box-shadow: 0px 3px 6px #00000029;
  cursor: pointer;
}
.boton-registrar:disabled {
  background: #d1d1d1 0% 0% no-repeat padding-box;
  border: none;
  cursor: not-allowed;
}
.inputMoney {
  border-bottom: 1px solid rgb(112, 112, 112, 0.39);
}

.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 27px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;
}
.indicador {
  position: absolute;
  content: '';
  height: 20px;
  width: 20px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #012a56;
}

.indicador.producto::before {
  content: 'P';
}

.indicador.servicio::before {
  content: 'S';
}

input:checked + .slider {
  background-color: #012a56;
}

input:focus + .slider {
  box-shadow: 0 0 1px #012a56;
}

input:checked + .slider .indicador {
  transform: translateX(20px);
}
</style>
